import {
  PaletteColorOptions,
  createTheme,
  responsiveFontSizes,
} from "@mui/material";
import "@fontsource/lato/100.css";
import "@fontsource/lato/300.css";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";
import "@fontsource/lato/900.css";
import "@fontsource/red-hat-display/300.css";
import "@fontsource/red-hat-display/400.css";
import "@fontsource/red-hat-display/500.css";
import "@fontsource/red-hat-display/600.css";
import "@fontsource/red-hat-display/700.css";
import "@fontsource/red-hat-display/900.css";
import foreverFreedomItalic from "../assets/fonts/Forever-Freedom-Italic.woff";
import foreverFreedomRegular from "../assets/fonts/Forever-Freedom-Regular.woff";


declare module "@mui/material/styles" {
  interface PaletteOptions {
    brand?: PaletteColorOptions;
  }
  interface SimplePaletteColorOptions {
    blue?: string;
  }
  interface TypeText {
    light?: string;
  }
}

export const gradientDarkBackground = "linear-gradient(180deg, #323335 0%, #434343 100%)"
export const gradientBlueBackground = "linear-gradient(90deg, #3A5465 0%, #6A99B8 100%)"

// TODO assign shadows to proper elevations from figma
export const boxShadow = "0px 3px 6px rgba(0, 0, 0, 0.1), 0px 4px 8px rgba(0, 0, 0, 0.08), 0px 1px 12px rgba(0, 0, 0, 0.04)"

const theme = responsiveFontSizes(
  createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#434343',
        light: '#cececf',
      },
      secondary: {
        main: '#f7c873',
        light: '#FAEBCD',
        dark: '#C8A375',
        contrastText: '#434343',
      },
      background: {
        default: '#f3f3f3',
      },
      text: {
        secondary: '#545556',
        primary: '#434343',
      },
      brand: {
        main: '#F7C873',
        light: "#F8F8F8"
      },
      error: {
        main: '#F44334',
      },
      warning: {
        main: '#C8A375',
      },
      info: {
        main: '#3A5465',
      },
      success: {
        main: '#72A774',
      },
      grey:{
        100: "#CECECF",
        200: "#B6B6B7",
        300: "rgba(133, 133, 134, 1)",
        400: "rgba(84, 85, 86, 1)",
        600: "#232426"
      }
    },
    typography: {
      fontFamily:
        "'Red Hat Display', Lato, 'Forever Freedom', sans-serif",
      // h1: {
      //   fontWeight: 600,
      //   letterSpacing: -1.5
      // },
      // h2: {
      //   fontWeight: 700,
      // },
      // h3: {
      //   fontWeight: 700,
      // },
      h4: {
        fontWeight: 700,
      },
      // h5: {
      //   fontWeight: 500,
      // },
      // h6: {
      //   fontWeight: 500,
      // },
      // body1: {
      //   fontWeight: 400,
      // },
      // subtitle2: {
      //   fontWeight: 500,
      // },
      // body2: {
      //   fontWeight: 400,
      // },
      // button: {
      //   fontWeight: 500,
      // },
      caption: {
        color: "#9c9c9c"
      }
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: `
        @font-face {
          font-family: "Forever Freedom";
          font-style: italic;
          src: url('${foreverFreedomItalic}') format("woff");
          font-display: swap;
        }
        @font-face {
          font-family: "Forever Freedom";
          font-style: normal;
          src: url('${foreverFreedomRegular}') format("woff");
          font-display: swap;
        }
        `,
      },
    },
  })
);

export default theme;
